import { ReactNode } from 'react';
import { formatDateTime } from '../../../../lib/hooks/utils';
import { OfferCheckoutOrganizationDetailsResponseDto } from '../../../../lib/interfaces/organisation';
import { H4, H5 } from '../../../../ui/components/ui/headings';
import { PAYMENT_METHOD_LABEL } from '../../../offer-checkout/constants/payment-method';
import { PaymentMethod } from '../../../offer-checkout/constants/payment-method.enum';
import { formatEuro } from '../../../offer-checkout/lib/format';

export interface OfferCheckoutCardProps {
  offer: OfferCheckoutOrganizationDetailsResponseDto;
}

const Row = ({ label, children }: { label: string; children: ReactNode }) => (
  <p className="text-[16px] text-[#888]">
    <span className="font-bold">{label}: </span>
    {children}
  </p>
);

/** The accepted offer next to the company data – same look as the self-checkout card, read only. */
const OfferCheckoutCard = ({ offer }: OfferCheckoutCardProps) => (
  <div className="flex flex-col py-7 px-9 bg-white rounded-lg gap-[14px] w-1/4">
    <H4>Angebot</H4>
    <div className="grid grid-cols-1">
      <Row label="Produkt">{offer.productTitle}</Row>
      <Row label="Preis">{formatEuro(offer.monthlyPriceCents)} netto / Monat</Row>
      <Row label="Laufzeit">
        {offer.termMonths} {offer.termMonths === 1 ? 'Monat' : 'Monate'}
      </Row>
      <Row label="Zahlungsart">{PAYMENT_METHOD_LABEL[offer.paymentMethod]}</Row>
      {offer.addOns.length > 0 && <Row label="Inklusive">{offer.addOns.map(({ title }) => title).join(', ')}</Row>}
      {offer.additionalConditions && <Row label="Konditionen">{offer.additionalConditions}</Row>}

      <hr className="my-2" />
      <H5>Nachweis</H5>
      <Row label="Angenommen am">{formatDateTime(offer.acceptedAt)}</Row>
      <Row label="IP-Adresse">{offer.ip}</Row>
      <Row label="AGB">{offer.termsAccepted ? 'akzeptiert' : 'nicht akzeptiert'}</Row>
      {offer.paymentMethod === PaymentMethod.SEPA && <Row label="SEPA-Mandat">{offer.sepaMandateAccepted ? 'erteilt' : 'nicht erteilt'}</Row>}
      {offer.attachments.length > 0 && <Row label="Vertragsunterlagen">{offer.attachments.map(({ title }) => title).join(', ')}</Row>}
    </div>
  </div>
);

export default OfferCheckoutCard;
